import type {
  AdminSettingsUserBase,
  HrAdminSettingsUser,
} from "../../services/admin-settings/type";

type FilterAdminSettingsUsersParams<TUser extends AdminSettingsUserBase = AdminSettingsUserBase> = {
  users: TUser[];
  searchText: string;
  selectedSecurityGroups: string[] | null;
};

type FilterHrAdminSettingsUsersParams = FilterAdminSettingsUsersParams<HrAdminSettingsUser>;
type FilterAtsAdminSettingsUsersParams = FilterAdminSettingsUsersParams;

export function compareText(a?: string, b?: string) {
  return (a ?? "").localeCompare(b ?? "", undefined, {
    numeric: true,
    sensitivity: "base",
  });
}

export function filterAtsAdminSettingsUsers(params: FilterAtsAdminSettingsUsersParams) {
  const { users, searchText, selectedSecurityGroups } = params;
  const searchTextLower = searchText.toLowerCase();

  return users.filter((user) => {
    const matchesSearch =
      !searchTextLower ||
      user.name.toLowerCase().includes(searchTextLower) ||
      user.email.toLowerCase().includes(searchTextLower);

    const matchesSecurityGroups =
      selectedSecurityGroups === null ||
      selectedSecurityGroups.length === 0 ||
      user.securityGroups.some((group) => selectedSecurityGroups.includes(group.id));

    return matchesSearch && matchesSecurityGroups;
  });
}

export function filterSecurityGroupMembers(params: {
  users: HrAdminSettingsUser[];
  searchText: string;
}) {
  const { users, searchText } = params;
  const searchTextLower = searchText.toLowerCase();

  return users.filter(
    (user) =>
      !searchTextLower ||
      user.employeeNumber.toLowerCase().includes(searchTextLower) ||
      user.name.toLowerCase().includes(searchTextLower) ||
      user.email.toLowerCase().includes(searchTextLower) ||
      user.jobTitle?.toLowerCase().includes(searchTextLower)
  );
}

export function filterHrAdminSettingsUsers(params: FilterHrAdminSettingsUsersParams) {
  const { users, searchText, selectedSecurityGroups } = params;
  const searchTextLower = searchText.toLowerCase();

  return users.filter((user) => {
    const matchesSearch =
      !searchTextLower ||
      user.name.toLowerCase().includes(searchTextLower) ||
      user.email.toLowerCase().includes(searchTextLower) ||
      user.employeeNumber.toLowerCase().includes(searchTextLower) ||
      user.department?.toLowerCase().includes(searchTextLower) ||
      user.jobTitle?.toLowerCase().includes(searchTextLower);

    const matchesSecurityGroups =
      selectedSecurityGroups === null ||
      selectedSecurityGroups.length === 0 ||
      user.securityGroups.some((group) => selectedSecurityGroups.includes(group.id));

    return matchesSearch && matchesSecurityGroups;
  });
}
